export default "__VITE_ASSET__CdoQXpai__"